import type { Article } from "@/types/content";

export const articles: Article[] = [
  {
    id: "complete-version-length",
    title: "《色戒》完整版：片长、版本与剪辑差异考据",
    excerpt:
      "从院线版到完整版，逐一梳理公开资料中关于片长、删减段落与镜头调度的差异，帮你在观影前建立清晰的版本认知，避免被各种说法带偏。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20stacked%20metal%20film%20canisters%20on%20a%20dark%20wooden%20table%2C%20warm%20amber%20lamp%20light%2C%20deep%20crimson%20velvet%20curtain%20blurred%20in%20the%20background%2C%20cinematic%20still%20life%20photography%2C%20rich%20shadows%2C%20subtle%20dust%20particles%2C%20moody%20archival%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=sejie-card-reels-01&orientation=landscape",
    category: "version",
    tags: ["完整版", "版本考据", "片长", "剪辑"],
    date: "2026-09-28",
    views: 18240,
    readTime: 9,
    author: "影档编辑部",
    sections: [
      {
        heading: "版本命名与片长基准",
        body: "在公开资料里，关于本片长度存在多个说法，差异主要来自统计口径：是否计入片头厂标、片尾字幕，以及国际发行版本的帧率换算。整理这些数字时，我们更建议先确认口径，再比较长短，否则很容易把发行差异误读成内容删减。",
      },
      {
        heading: "被讨论最多的三处差异",
        body: "影迷讨论最集中的段落，通常围绕人物关系的推进节奏、室内戏的镜头停留时间，以及部分场景的转场方式。这些差异并不改变故事走向，但会明显改变观众对角色动机的理解速度，也因此成为版本讨论的焦点。",
      },
      {
        heading: "版本差异如何影响叙事节奏",
        body: "当某些镜头被压缩，人物的犹豫会被削弱，情节看起来更利落，却也更冷。完整版本的节奏更慢，留白更多，观众被迫与角色一起待在沉默里——这正是许多影评认为它更接近原作气质的原因。",
      },
    ],
  },
  {
    id: "novel-to-screen",
    title: "从张爱玲到银幕：完整版的叙事结构全解",
    excerpt:
      "小说里大量留白如何被转译成镜头语言？我们从叙事时间、视角切换与场景调度三个层面，拆解这次改编为何值得反复观看。",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20old%20novel%20manuscript%20pages%20with%20a%20fountain%20pen%20resting%20on%20top%2C%20dark%20walnut%20desk%2C%20single%20warm%20reading%20lamp%2C%20crimson%20silk%20ribbon%20bookmark%2C%20shallow%20depth%20of%20field%2C%20muted%20moody%20color%20grading%2C%20editorial%20still%20life%2C%20fine%20paper%20texture%2C%20no%20text&width=800&height=600&seq=sejie-card-manuscript-02&orientation=landscape",
    category: "version",
    tags: ["完整版", "改编", "叙事结构", "文学"],
    date: "2026-09-21",
    views: 15320,
    readTime: 11,
    author: "林砚",
    sections: [
      {
        heading: "时间的折叠方式",
        body: "小说用回忆把数年压缩成几段锋利的片段，电影则把时间摊开：从学生时代的躁动，到重逢后的试探，每一段都被赋予具体的空间与气味。完整版本的耐心，让这种摊开成为可能。",
      },
      {
        heading: "视角的摇摆",
        body: "镜头很少长时间停留在单一人物身上，它更像一个犹疑的旁观者，在两个人之间来回移动。观众因此无法安稳地站队，只能在一次次视线交换中自行判断谁在说谎。",
      },
      {
        heading: "场景作为潜台词",
        body: "雨、窗帘、镜面、狭窄的走廊，这些场景元素承担了大量原作中由叙述者完成的心理描写。看懂空间，往往比听懂台词更接近人物的真实处境。",
      },
    ],
  },
  {
    id: "ring-and-betrayal",
    title: "影评：一枚钻戒背后的信任与背叛",
    excerpt:
      "珠宝店里那颗钻石不是爱情的信物，而是整部电影最精密的一次权力交换。本文从道具调度与光线变化，看人物崩塌的那一瞬间。",
    cover:
      "https://readdy.ai/api/search-image?query=Macro%20photograph%20of%20a%20vintage%20diamond%20ring%20resting%20on%20deep%20crimson%20silk%2C%20dark%20velvet%20surface%2C%20single%20soft%20key%20light%20creating%20sparkling%20facets%2C%20warm%20gold%20reflections%2C%20luxurious%20restrained%20composition%2C%20cinematic%20jewelry%20still%20life%2C%20rich%20shadow%20falloff%2C%20no%20text&width=800&height=600&seq=sejie-card-ring-03&orientation=landscape",
    category: "review",
    tags: ["影评", "道具", "人物心理", "镜头语言"],
    date: "2026-09-16",
    views: 21670,
    readTime: 8,
    author: "沈知微",
    sections: [
      {
        heading: "光落在戒面上的那一刻",
        body: "珠宝店是全片少见的明亮空间，白光的冷感与人物手心的汗形成微妙对照。镜头不急着给钻石特写，而是先给犹豫的手，再给被放大的光——观众和角色同时被那道光刺了一下。",
      },
      {
        heading: "交换的从来不是礼物",
        body: "在整条叙事线上，戒指是一次公开的确认，也是一次公开的暴露。它把两个人之间所有尚未说出口的默契，变成了可以被他人看见的物证，从而彻底改变了后续的走向。",
      },
      {
        heading: "崩塌只需要一句低声的话",
        body: "真正击穿防线的不是戒指本身，而是那句几乎听不见的低语。完整版本在这里给予了足够长的静默，让观众听见自己心里那声“糟了”。",
      },
    ],
  },
  {
    id: "wang-jiazhi-silence",
    title: "影评：王佳芝的沉默，比台词更响",
    excerpt:
      "她把所有情绪收进眼神和手指的细微动作里。本文梳理片中几处近乎无声的表演，谈谈角色如何被沉默一点一点塑造出来。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20silhouette%20of%20a%20woman%20in%20a%20dark%20cheongsam%20standing%20beside%20a%20rain-streaked%20window%2C%20warm%20amber%20light%20from%20a%20single%20table%20lamp%2C%20deep%20crimson%20curtain%2C%20soft%20haze%2C%20painterly%20cinematic%20composition%2C%20limited%20palette%2C%20fine%20film%20grain%2C%20melancholic%20atmosphere%2C%20no%20text&width=800&height=600&seq=sejie-card-silhouette-04&orientation=landscape",
    category: "review",
    tags: ["影评", "表演", "人物心理"],
    date: "2026-09-09",
    views: 17420,
    readTime: 7,
    author: "顾南声",
    sections: [
      {
        heading: "手比脸更诚实",
        body: "片中多次出现手指的特写：捏紧杯壁、抚平衣角、停在门把上迟迟不推开。这些动作几乎没有表演痕迹，却把角色的权衡暴露得一干二净。",
      },
      {
        heading: "被咽下去的对白",
        body: "有些台词说到一半就断了，留下的空白比完整句子更重。导演没有用配乐填补这些空白，而是让房间里的钟表声、衣料摩擦声接管情绪。",
      },
      {
        heading: "沉默的代价",
        body: "当一个人长期依靠沉默来保护自己，沉默最终会变成她唯一能做的选择。这也是影片最残忍的地方：它让观众理解了这个选择，却无法替她承担后果。",
      },
    ],
  },
  {
    id: "behind-shanghai-set",
    title: "幕后：如何重建一九四二年的上海街景",
    excerpt:
      "从街道路面到招牌字体，美术团队用数月时间搭建出一条可以“走进去”的老街。本文整理公开访谈中的置景细节与考据方法。",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20period%20film%20set%20recreating%201940s%20Shanghai%20street%2C%20vintage%20camera%20on%20a%20dolly%2C%20lighting%20rigs%20and%20smoke%20diffusers%2C%20neon%20signboards%20in%20Chinese%20characters%2C%20warm%20tungsten%20glow%2C%20dusty%20atmospheric%20haze%2C%20documentary%20photography%2C%20no%20text&width=800&height=600&seq=sejie-card-filmset-05&orientation=landscape",
    category: "behind",
    tags: ["幕后", "美术", "场景", "拍摄花絮"],
    date: "2026-09-02",
    views: 9860,
    readTime: 10,
    author: "影档编辑部",
    sections: [
      {
        heading: "先做考据，再做布景",
        body: "美术组先从旧照片、广告月份牌与地图入手，确认街道宽度、店铺类型与招牌排布，再决定哪里可以艺术加工。越是看起来不起眼的角落，越需要真实的依据。",
      },
      {
        heading: "能让演员走进去的空间",
        body: "实景搭建的关键不只是“像”，而是“能用”：门要能推开，楼梯要能承重，柜台要能摆放真实的道具。只有空间成立，演员的走位才会自然。",
      },
      {
        heading: "光与烟共同完成的年代感",
        body: "现场大量使用烟雾与暖色灯具制造空气感，让远处街景自然虚化。这种处理既节省了细节成本，也让画面更接近老胶片留下的朦胧记忆。",
      },
    ],
  },
  {
    id: "qipao-costume-code",
    title: "造型与旗袍：布料里的时代密码",
    excerpt:
      "二十余套旗袍不是时装展示，而是角色处境的注脚。从剪裁、颜色到领口高度，看服装如何安静地参与叙事。",
    cover:
      "https://readdy.ai/api/search-image?query=Rows%20of%20elegant%20vintage%20Chinese%20cheongsam%20dresses%20hanging%20in%20a%20tailoring%20studio%2C%20rich%20crimson%2C%20jade%20and%20deep%20gold%20fabrics%2C%20warm%20tungsten%20light%2C%20wooden%20hangers%2C%20sewing%20table%20with%20measuring%20tape%2C%20shallow%20depth%20of%20field%2C%20nostalgic%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=sejie-card-qipao-06&orientation=landscape",
    category: "behind",
    tags: ["幕后", "造型", "服装", "时代背景"],
    date: "2026-08-26",
    views: 11250,
    readTime: 8,
    author: "苏迟",
    sections: [
      {
        heading: "剪裁就是处境",
        body: "早期的旗袍更宽松，颜色也偏素；随着角色进入更复杂的关系，面料变得讲究，腰线收紧，领口的高度也随之变化。衣服替她说出了不能说的话。",
      },
      {
        heading: "颜色的克制",
        body: "全片很少出现高饱和的色彩，红是暗红，绿是墨绿。造型指导刻意压低明度，让人物始终像是被时代的光线压住，无法真正鲜亮起来。",
      },
      {
        heading: "细节里的时间",
        body: "盘扣、滚边、衬里的选择都对应着具体年份与阶层。观众未必能一一辨认，但这些细节共同支撑起一个可信的世界，让情绪有地方落脚。",
      },
    ],
  },
  {
    id: "mahjong-table-tension",
    title: "剧情解析：三场麻将戏里的暗流",
    excerpt:
      "牌桌上的每一次碰牌都是试探。本文按时间顺序拆解三场麻将戏中的人物位置、台词潜台词与镜头距离，看清关系的推进。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20mahjong%20game%20on%20an%20ornate%20wooden%20table%20in%20a%201940s%20Chinese%20mansion%2C%20ivory%20tiles%2C%20porcelain%20teacups%2C%20warm%20lamp%20glow%2C%20smoke%20haze%2C%20hands%20of%20elegantly%20dressed%20women%2C%20deep%20crimson%20and%20gold%20tones%2C%20cinematic%20interior%20photography%2C%20no%20text&width=800&height=600&seq=sejie-card-mahjong-07&orientation=landscape",
    category: "analysis",
    tags: ["剧情解析", "场景", "人物关系"],
    date: "2026-08-19",
    views: 24180,
    readTime: 12,
    author: "林砚",
    sections: [
      {
        heading: "座位即权力",
        body: "三场麻将戏的座位安排各不相同，谁背对门口、谁正对光源、谁被夹在中间，都暗示了当下的权力结构。牌局是社交，也是一次没有硝烟的审讯。",
      },
      {
        heading: "台词的双层结构",
        body: "太太们聊的是首饰、布料与家常，真正被讨论的却是行踪、关系与信任。观众需要同时听两层话，才能理解为什么一句随口的玩笑会让气氛骤然收紧。",
      },
      {
        heading: "镜头为什么不肯靠近",
        body: "镜头始终保持在牌桌外一小段距离，像另一个不便插话的旁观者。这种克制的距离感，让暗流始终停留在水面之下，直到最后一局才浮出。",
      },
    ],
  },
  {
    id: "ending-light-shadow",
    title: "剧情解析：结尾处的光与影",
    excerpt:
      "结尾十分钟几乎没有配乐，只有脚步声与光影的推移。我们逐段拆解这段调度，理解它为何让人久久不能平静。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20rain-soaked%20cobblestone%20street%20at%20night%20in%20old%20Shanghai%2C%20single%20glowing%20street%20lamp%2C%20wet%20reflections%20on%20the%20ground%2C%20deep%20shadows%2C%20distant%20silhouette%20of%20a%20person%20walking%20away%2C%20crimson%20and%20amber%20color%20grading%2C%20cinematic%20wide%20shot%2C%20heavy%20atmosphere%2C%20no%20text&width=800&height=600&seq=sejie-card-nightstreet-08&orientation=landscape",
    category: "analysis",
    tags: ["剧情解析", "结尾", "镜头语言"],
    date: "2026-08-12",
    views: 26840,
    readTime: 9,
    author: "沈知微",
    sections: [
      {
        heading: "声音先撤走",
        body: "配乐在关键节点提前退场，只剩下脚步声、雨声与远处的车响。听觉上的空，让观众不得不把注意力交回画面，也让时间变得异常漫长。",
      },
      {
        heading: "光的方向在改变",
        body: "结尾的光源从室内暖光转为街灯冷光，人物脸上的阴影面积逐渐扩大。这种变化不需要台词解释，就能传达出某种不可逆的失去。",
      },
      {
        heading: "留下一个不肯收尾的空镜",
        body: "最后一个镜头没有给答案，只给了空间。正是这份不解释，让影片的余味得以延续到片尾字幕之后。",
      },
    ],
  },
  {
    id: "yi-mr-gaze",
    title: "影评：易先生的眼神戏与权力疲态",
    excerpt:
      "一个习惯掌控他人的人在镜头前逐渐失去掌控。本文分析几场对手戏中视线的方向变化，以及它带来的持续不安感。",
    cover:
      "https://readdy.ai/api/search-image?query=Low%20key%20portrait%20of%20a%20man%20in%20a%20dark%20tailored%20suit%20seated%20at%20a%20vintage%20desk%2C%20cigarette%20smoke%20curling%20in%20a%20shaft%20of%20warm%20light%2C%20dark%20wood%20panelled%20office%2C%20deep%20red%20accents%2C%20moody%20noir%20cinematography%2C%20strong%20chiaroscuro%2C%20serious%20atmosphere%2C%20no%20text&width=800&height=600&seq=sejie-card-office-09&orientation=landscape",
    category: "review",
    tags: ["影评", "表演", "人物心理", "镜头语言"],
    date: "2026-08-05",
    views: 14960,
    readTime: 8,
    author: "顾南声",
    sections: [
      {
        heading: "视线是权力工具",
        body: "在前半段，他几乎从不先移开目光，视线是一种压制。到了后半段，反而是他先低头、先侧脸、先看向窗外。这种细微的颠倒，比任何冲突都更能说明关系的变化。",
      },
      {
        heading: "疲惫从肩膀开始",
        body: "表演把疲惫放在身体上：坐姿稍稍塌陷，解扣子的动作变慢，听人说话时眼神短暂失焦。角色的脆弱不是被演出来的，而是被一点点泄露的。",
      },
      {
        heading: "反派不需要解释",
        body: "影片拒绝为这个人物提供道德辩护，也不急着审判他。它只是把一个人如何在权力与恐惧中消耗自己，完整地呈现在光里。",
      },
    ],
  },
  {
    id: "score-and-silence",
    title: "声音设计：当配乐选择沉默",
    excerpt:
      "片中大量段落刻意留白，让环境声承担情绪推进。本文从声音层面复盘完整版本的听觉设计，以及它如何影响观众的身体感受。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20gramophone%20with%20a%20spinning%20shellac%20record%20in%20a%20dim%20wooden%20room%2C%20warm%20amber%20light%20falling%20across%20the%20horn%2C%20deep%20crimson%20curtain%20behind%2C%20visible%20dust%20motes%2C%20nostalgic%20cinematic%20still%20life%2C%20muted%20cinematic%20color%20grading%2C%20no%20text&width=800&height=600&seq=sejie-card-gramophone-10&orientation=landscape",
    category: "analysis",
    tags: ["剧情解析", "声音", "配乐"],
    date: "2026-07-29",
    views: 8890,
    readTime: 7,
    author: "苏迟",
    sections: [
      {
        heading: "留白不是空白",
        body: "当音乐退场，观众的注意力会被重新分配给环境：楼下的麻将声、窗外的雨、布料摩擦的轻响。这些声音看似无关紧要，却在暗中标记着时间与危险的距离。",
      },
      {
        heading: "主题旋律的克制使用",
        body: "主题音乐出现的次数极少，每次都在人物情绪即将溃堤之前。它更像一个提醒，而不是情绪的替代品，因此每次都格外有分量。",
      },
      {
        heading: "听觉上的不适感",
        body: "有些段落故意拉长声音的余响，让空间显得比画面更大。这种处理制造出一种被窥视的不适，恰好与故事的处境相呼应。",
      },
    ],
  },
  {
    id: "archive-newspapers",
    title: "资料档案：当年的报纸与宣传物料",
    excerpt:
      "整理公开可查的报纸版面、剧照与宣传册信息，说明这些资料如何帮助我们理解影片的时代语境与当时的观众反应。",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20aged%20Chinese%20newspapers%20and%20archival%20boxes%20on%20a%20library%20table%2C%20yellowed%20paper%20edges%2C%20brass%20reading%20lamp%2C%20warm%20sepia%20tones%2C%20shallow%20depth%20of%20field%2C%20quiet%20research%20atmosphere%2C%20editorial%20photography%2C%20soft%20shadows%2C%20no%20text&width=800&height=600&seq=sejie-card-archive-11&orientation=landscape",
    category: "version",
    tags: ["完整版", "资料", "时代背景"],
    date: "2026-07-22",
    views: 7320,
    readTime: 6,
    author: "影档编辑部",
    sections: [
      {
        heading: "报纸上的边角信息",
        body: "当年的报纸版面往往夹杂着影院排片、服装广告与社会新闻。把这些边角信息拼起来，能还原出一个更具体的城市日常，也让影片中的街景有了参照。",
      },
      {
        heading: "剧照与宣传册的差别",
        body: "宣传物料为了突出卖点，会选取更明亮的构图；而影片本身的光线要沉得多。对比两者，可以看出当时发行方对观众期待的判断。",
      },
      {
        heading: "资料阅读的方法",
        body: "建议先建立时间线，再按人物、场景、道具分类归档。这样在查阅版本差异或幕后细节时，能快速判断某条说法是否有据可依。",
      },
    ],
  },
];